//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {VueShowdown} from 'vue-showdown'
export default {
  name: 'AppModal',
  components: {
    VueShowdown
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    }
  }
}
